<template>
  <div class="container course-create">
    <div class="header">
      <el-breadcrumb class="breadcrumb"
                     separator="/">
        <el-breadcrumb-item>基础数据</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/service/list' }">金牌客服</el-breadcrumb-item>
        <el-breadcrumb-item>客服创建</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
        </div>
        <div class="right">
          <el-button plain
                     @click="handleClose">取消</el-button>
          <el-button type="primary"
                     @click="handleSubmit">保存</el-button>
        </div>
      </div>
    </div>
    <div class="main">
      <h3 class="title">客服资料</h3>
      <div class="content">
        <el-form :model="dataForm"
                 :rules="rules"
                 ref="dataForm"
                 label-width="130px"
                 class="dataForm">
          <el-form-item label="客服名称"
                        prop="name">
            <el-input v-model="dataForm.name"
                      placeholder="请输入客服名称"></el-input>
          </el-form-item>
          <el-form-item label="客服头像"
                        prop="avatar">
            <el-upload class="avatar-uploader"
                       :action="imgUploadUrl"
                       :headers="uploadHeaders"
                       :show-file-list="false"
                       :on-success="handleUploadSuccess"
                       :before-upload="handleBeforeUpload">
              <img v-if="dataForm.avatar"
                   :src="dataForm.avatar"
                   class="avatar">
              <i v-else
                 class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="客服标签"
                        prop="tags">
            <el-input v-model="dataForm.tags"
                      placeholder="请输入客服标签，至多两个，用英文逗号隔开"></el-input>
          </el-form-item>
          <el-form-item label="客服描述"
                        prop="description">
            <el-input v-model="dataForm.description"
                      placeholder="请输入客服描述"></el-input>
          </el-form-item>
          <el-form-item label="客服手机号"
                        prop="mobile">
            <el-input v-model="dataForm.mobile"
                      placeholder="请输入客服手机号"></el-input>
          </el-form-item>
          <el-form-item label="客服微信号"
                        prop="wechat">
            <el-input v-model="dataForm.wechat"
                      placeholder="请输入客服微信号"></el-input>
          </el-form-item>
          <el-form-item label="企业微信链接"
                        prop="wechat">
            <el-input v-model="dataForm.enterprise_wechat_url"
                      placeholder="请输入企业微信链接"></el-input>
          </el-form-item>
          <el-form-item label="客户端"
                        prop="client_ids">
            <el-select v-model="dataForm.client_ids"
                       multiple
                       placeholder="请选择客户端"
                       style="width: 100%;">
              <el-option v-for="item in clients"
                         :key="item.id"
                         :label="item.name"
                         :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="微信二维码"
                        prop="qrcode">
            <el-upload class="avatar-uploader"
                       :action="imgUploadUrl"
                       :headers="uploadHeaders"
                       :show-file-list="false"
                       :on-success="handleUploadQrcodeSuccess"
                       :before-upload="handleBeforeUpload">
              <img v-if="dataForm.qrcode"
                   :src="dataForm.qrcode"
                   class="avatar">
              <i v-else
                 class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="客服QQ号"
                        prop="qq">
            <el-input v-model="dataForm.qq"
                      placeholder="请输入客服QQ号"></el-input>
          </el-form-item>
          <el-form-item label="QQ号openid"
                        prop="qq_openid">
            <el-input v-model="dataForm.qq_openid"
                      placeholder="请输入客服QQ号openid"></el-input>
          </el-form-item>
          <el-form-item label="QQ群号码"
                        prop="qq_group">
            <el-input v-model="dataForm.qq_group"
                      placeholder="请输入QQ群号码"></el-input>
          </el-form-item>
          <el-form-item label="QQ群链接"
                        prop="qq_group_url">
            <el-input v-model="dataForm.qq_group_url"
                      placeholder="请输入QQ群链接"></el-input>
          </el-form-item>
          <el-form-item label="微信群二维码"
                        prop="wechat_group_qrcode">
            <el-upload class="avatar-uploader"
                       :action="imgUploadUrl"
                       :headers="uploadHeaders"
                       :show-file-list="false"
                       :on-success="handleUploadWechatGroupQrcodeSuccess"
                       :before-upload="handleBeforeUpload">
              <img v-if="dataForm.wechat_group_qrcode"
                   :src="dataForm.wechat_group_qrcode"
                   class="avatar">
              <i v-else
                 class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="客服介绍"
                        prop="detail">
            <el-input v-model="dataForm.detail"
                      type="textarea"
                      :rows="2"
                      placeholder="请输入客服介绍"></el-input>
          </el-form-item>
          <el-form-item label="开放状态"
                        prop="open_status">
            <el-switch v-model="dataForm.open_status"></el-switch>
          </el-form-item>
          <el-form-item label="上/下线"
                        prop="status">
            <el-switch v-model="dataForm.status"></el-switch>
          </el-form-item>
          <el-form-item label="适合专业："
                        prop="majors">
            <div class="tag-wrap">
              <el-tag class="subject-item"
                      size="medium"
                      :key="item.id"
                      v-for="item in majors"
                      closable
                      :disable-transitions="false"
                      @close="handleMajorRemove(item)">
                {{`${item.name}/${item.code}`}}
              </el-tag>
              <el-button type="text"
                         @click="handleMajorChoose">选择专业</el-button>
            </div>
          </el-form-item>
          <el-form-item label="适合院校："
                        prop="colleges">
            <div class="tag-wrap">
              <el-tag class="subject-item"
                      size="medium"
                      :key="item.id"
                      v-for="item in colleges"
                      closable
                      :disable-transitions="false"
                      @close="handleCollegeRemove(item)">
                {{`${item.name}`}}
              </el-tag>
              <el-button type="text"
                         @click="handleCollegeChoose">选择院校</el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>

    </div>
    <MajorChoose :visible="majorChooseDialog"
                 :majors="majors"
                 @close="majorChooseDialog = false"
                 @submit="saveMajor"></MajorChoose>
    <CollegeChoose :visible="collegeChooseDialog"
                   :colleges="colleges"
                   @close="collegeChooseDialog = false"
                   @submit="saveCollege"></CollegeChoose>
  </div>
</template>

<script>
import MajorChoose from '@/components/dialog/major/MajorChoose'
import CollegeChoose from '@/components/dialog/college/CollegeChoose'
import { imgUploadUrl, uploadHeaders } from '@/config/index'
import { serviceUpdate, serviceOne } from '@/api/common'
import { clientList } from '@/api/operation'

export default {
  components: {
    MajorChoose,
    CollegeChoose,
  },
  data() {
    return {
      majorChooseDialog: false,
      collegeChooseDialog: false,
      imgUploadUrl: imgUploadUrl(),
      uploadHeaders: uploadHeaders(),
      dataForm: {
        avatar: '',
        qrcode: '',
        wechat_group_qrcode: '',
      },
      majors: [],
      colleges: [],
      clients: [],
      rules: {
        name: [{ required: true, message: '请输入客服名称', trigger: 'blur' }],
        // tags: [{ required: true, message: '请输入客服标签', trigger: 'blur' }],
        // description: [
        //   { required: true, message: '请输入客服描述', trigger: 'blur' },
        // ],
        // mobile: [
        //   { required: true, message: '请输入客服手机号', trigger: 'blur' },
        // ],
        // wechat: [
        //   { required: true, message: '请输入客服微信号', trigger: 'blur' },
        // ],
        // detail: [
        //   { required: true, message: '请输入客服介绍', trigger: 'blur' },
        // ],
        avatar: [
          { required: true, message: '请上传客服头像', trigger: 'blur' },
        ],
        // qrcode: [
        //   { required: true, message: '请上传老师微信二维码', trigger: 'blur' },
        // ],
        // qq: [{ required: false, message: '请输入客服QQ号', trigger: 'blur' }],
        // qq_openid: [
        //   { required: false, message: '请输入客服QQ号openid', trigger: 'blur' },
        // ],
        // qq_group: [
        //   { required: false, message: '请输入QQ群号码', trigger: 'blur' },
        // ],
        // qq_group_url: [
        //   { required: false, message: '请输入QQ群链接', trigger: 'blur' },
        // ],
        // wechat_group_qrcoee: [
        //   { required: false, message: '请上传微信群二维码', trigger: 'blur' },
        // ],
      },
    }
  },
  created() {
    this.fetchClientList()
  },
  mounted() {
    this.scrollToTop()
    this.fetchServiceInfo()
  },
  methods: {
    fetchClientList() {
      clientList({ isPaging: 0 }).then((res) => {
        this.clients = res.list
        console.log('this.clients', this.clients)
      })
    },
    // 客服基本信息
    fetchServiceInfo() {
      serviceOne({ id: this.$route.params.serviceId }).then((res) => {
        if (res) {
          res.open_status = res.open_status === 1 ? true : false
          res.status = res.status === 1 ? true : false
          this.colleges = res.colleges || this.colleges
          this.majors = res.majors || this.majors
          this.dataForm = res
          this.$set(
            this.dataForm,
            'enterprise_wechat_url',
            res.enterprise_wechat_url
          )
          if (res.client_ids != '') {
            // console.log('333', res.client_ids.split(','))
            this.$set(
              this.dataForm,
              'client_ids',
              res.client_ids.split(',').map((item) => parseInt(item, 10))
            )
          }
        }
      })
    },
    scrollToTop() {
      // Chrome
      document.body.scrollTop = 0
      // Firefox
      document.documentElement.scrollTop = 0
      // Safari
      window.pageYOffset = 0
    },
    handleMajorRemove(item) {
      this.majors = this.majors.filter((v) => v.id !== item.id)
    },
    handleMajorChoose() {
      this.majorChooseDialog = true
    },
    saveMajor({ majors }) {
      this.majors = majors
    },
    handleCollegeRemove(item) {
      this.colleges = this.colleges.filter((v) => v.id !== item.id)
    },
    handleCollegeChoose() {
      this.collegeChooseDialog = true
    },
    saveCollege({ colleges }) {
      this.colleges = colleges
    },
    handleUploadSuccess(res, file) {
      if (res.code == 0 && res.data) {
        this.dataForm.avatar = res.data.url
      } else {
        this.$message.error(res.error)
      }
    },
    handleUploadQrcodeSuccess(res, file) {
      if (res.code == 0 && res.data) {
        this.dataForm.qrcode = res.data.url
      } else {
        this.$message.error(res.error)
      }
    },
    handleUploadWechatGroupQrcodeSuccess(res, file) {
      if (res.code == 0 && res.data) {
        this.dataForm.wechat_group_qrcode = res.data.url
      } else {
        this.$message.error(res.error)
      }
    },
    handleBeforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
      }
      return isLt2M
    },
    handleSubmit() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          let params = Object.assign({}, this.dataForm, {
            open_status: this.dataForm.open_status ? 1 : 0,
            status: this.dataForm.status ? 1 : 0,
            majors: this.majors.map((item) => ({
              code: item.code,
              college_code: item.college_code,
            })),
            colleges: this.colleges.map((item) => ({ code: item.code })),
          })
          if (params.client_ids.length > 0) {
            params.client_ids = params.client_ids.join(',')
          } else {
            params.client_ids = ''
          }
          params.detail = this.dataForm.detail ? this.dataForm.detail : ''
          serviceUpdate(params)
            .then((res) => {
              this.$message.success(`编辑成功`)
              this.$refs['dataForm'].resetFields()

              this.$router.go(-1)
            })
            .catch((error) => {
              console.log('error: ', error)
            })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    handleClose() {
      this.$router.go(-1)
    },
  },
}
</script>

<style scoped lang="less">
.course-create {
  .header {
    background: #fff;
    padding: 20px;

    .breadcrumb {
      margin-bottom: 20px;
    }
    .content {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }
  .main {
    background: #fff;
    padding: 20px;
    margin-top: 10px;

    .title {
      font-size: 32px;
      font-weight: bold;
    }
  }
  .content {
    display: flex;
    margin-top: 20px;

    .dataForm {
      min-width: 700px;
      // width: 100%;
    }

    .button {
      font-size: 14px;
      padding: 12px 20px;
      margin-bottom: 10px;

      &.small {
        padding: 9px 15px;
      }
    }
    .avatar-uploader /deep/ .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .avatar-uploader /deep/ .el-upload:hover {
      border-color: #409eff;
    }
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 128px;
      height: 128px;
      line-height: 128px;
      text-align: center;
    }
    .avatar {
      display: block;
      width: 128px;
      height: 128px;
      object-fit: cover;
    }
    .tag-wrap {
      display: flex;
      flex-wrap: wrap;
    }
    .subject-item,
    .teacher-item {
      margin-right: 5px;
      margin-bottom: 5px;
    }
  }
  .form-header {
    font-size: 14px;
    font-weight: bold;
    color: #333;
    background: #f8f8f8;
    margin-bottom: 20px;

    .form-header-inner {
      padding: 10px;
    }
  }
}
</style>
